// Campus photo for /colleges/carnegie-mellon-university: CC0 1.0, by Cbaile19, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AHamerschlag_Hall%2C_Carnegie_Mellon_University%2C_2023-04-27%2C_01.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/carnegie-mellon-university/; credited under the photo.
const photo = {
    "slug": "carnegie-mellon-university",
    "alt": "Hamerschlag Hall at Carnegie Mellon University in Pittsburgh, Pennsylvania, with the University of Pittsburgh's Cathedral of Learning in the distance",
    "src": "/colleges/carnegie-mellon-university/campus-1600.webp",
    "srcSmall": "/colleges/carnegie-mellon-university/campus-800.webp",
    "srcMid": "/colleges/carnegie-mellon-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/carnegie-mellon-university/og.jpg",
    "title": "Hamerschlag Hall, Carnegie Mellon University, 2023-04-27, 01",
    "author": "Cbaile19",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AHamerschlag_Hall%2C_Carnegie_Mellon_University%2C_2023-04-27%2C_01.jpg",
    "read": "2026-10-01"
};

export default photo;
